module.exports = __webpack_public_path__ + "static/media/MaintenanceIcon.f0119d26.svg";